export const StateKeys = {
  recentlySelectedLocations: 'homebot:gallery:recentlySelectedLocations',
  currentSelectedLocation: 'homebot:gallery:currentSelectedLocation',
  currentSearchLocation: 'homebot:gallery:currentSearchLocation',
  homeSearchMapState: 'homebot:gallery:homeSearchMapState',
  firstFavoriteProperty: 'homebot:gallery:firstFavoriteProperty',
  customDebtCalculatorResults: 'homebot:equityUnlock:customDebtCalculatorResults',
  aiChatSessionMessages: 'homebot:aiChat:sessionMessages'
}
